import ErrorCone from '../../../assets/empty-state-machines.svg';
import { Button } from '@nexelem/components';
import { useCustomTranslation } from '../../hooks';

export const HydrationErrorPage = () => {
  const { t, tWrapper } = useCustomTranslation('errors');
  return (
    <div className="flex h-full flex-col items-center justify-center overflow-auto pb-8">
      <img
        alt="error cone"
        aria-hidden="true"
        className="max-h-[500px] w-full object-contain"
        role="presentation"
        src={ErrorCone}
      />
      <span className="mt-9 text-s18-sb">{tWrapper('hydrationErrorHeader')}</span>
      <span className="mt-2 max-w-[500px] text-center text-s18">{tWrapper('hydrationErrorDescription')}</span>
      <Button className="mt-5 shrink-0" variant="outlined" onClick={() => window.location.reload()}>
        {t('common.refreshPage')}
      </Button>
    </div>
  );
};
